export enum AirbridgeEvents {
  ECOMMERCE_PRODUCT_VIEWED = 'airbridge.ecommerce.product.viewed',
  EVENT_PAGE_QNA_WRITE_VIEW = 'event_page_qna_write_view',
  EVENT_PAGE_QNA_COMPLETE = 'event_page_qna_complete',
  ECOMMERCE_ORDER_COMPLETED = 'airbridge.ecommerce.order.completed',
  CONVERSION_BUTTON_CLICK = 'conversion_button_click',
  ADD_TO_WISH_LIST = 'airbridge.addToWishlist',
  CONCERN_COMPLETE = 'concern_complete',
  HOSPITAL_PAGE_VIEW = 'hospital_page_view',
  HOME_PAGE_VIEW = 'airbridge.ecommerce.home.viewed',
  USER_SIGN_UP = 'airbridge.user.signup',
  USER_SIGN_IN = 'airbridge.user.signin',
  USER_SIGN_OUT = 'airbridge.user.signout',
  SIGN_UP_BUTTON_CLICK_IN_WEB = 'signuplogin_button_click',
  COMMUNITY_VIEW = 'community_view',
  POST_LANDINGBTN_CLICK = 'post_button_click',
  EVENT_VIEW = 'event_view',
  HOME_BANNER_CLICK = 'home_banner_click',
  REVIEW_EVENTPAGE_VIEW = 'review_eventpage_view',
  REVIEW_HOSPITALPAGE_CLICK = 'review_hospitalpage_click',
  COMMUNITY_CATEGORY_VIEW = 'community_category_view',
  COMMUNITY_PAGE_VIEW = 'community_page_view',
  SEARCH_VIEW = 'search_view',
  AIRBRIDGE_ECOMMERCE_SEARCH_RESULTS_VIEWED = 'airbridge.ecommerce.searchResults.viewed',
  MYPAGE_VIEW = 'mypage_view',
  MYPAGE_CATEGORY_CLICK = 'mypage_category_click',
  HOSPITAL_VIEW = 'hospital_view',
  DOCTOR_PAGE_VIEW = 'doctor_page_view',
  APP_DOWNLOAD_BUTTON_CLICK = 'appdownload_button_click',
  APP_DOWNLOAD_BUTTON_CLICK2 = 'appdownload_button_click2',
  WISH_LIST_VIEW = 'wishlist_view',
}
